// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c536172","239":"414c17d7","455":"de8ba0b7"}[chunkId] + ".chunk.js";
};